import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentLoanListAction from './equipmentLoanList.action.json' with { type: 'json' }
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import { equipmentLoanObject } from '../equipmentLoanObject'

export const equipmentLoanExpression = expression(equipmentLoanObject.shape)

const equipmentLoanListDefinition = defineAction({
  ...equipmentLoanListAction,

  input: z.object({
    filter: equipmentLoanExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      loanDate: 'Data do empréstimo',
      estimatedDevolutionDate: 'Data estimada de devolução',
      returned: 'Devolvido',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(equipmentLoanObject),
    count: z.number(),
  }),
})

export default equipmentLoanListDefinition
